import React from 'react';
import { Header } from 'common/components/Header';
import QRCode from 'qrcode.react';
import { Spin, message } from 'antd';
import styled from 'styled-components';
import { Formik } from 'formik';
import { MfaCodeForm } from 'common/organisms/MfaCodeForm';
import { twoFactorPinCodeValidationSchema } from 'common/config/validationSchema';
import { useMutation, useQuery } from 'react-query';
import { UsersAPI } from 'api/UsersAPI';
import { useDispatch } from 'react-redux';
import { authActions } from 'state/auth/auth.actions';
import { FormattedMessage } from 'react-intl';
import { useFormatMessage } from 'common/hooks/useFormatMessage';

const CodeDataWrapper = styled.div`
  margin: 3rem 0;
  display: flex;
`;

export const Loader = styled(Spin)`
  min-height: 300px;
  min-width: 25%;
  max-width: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SecretData = styled.div`
  max-width: 25rem;
  margin-left: 4rem;
`;

export const MfaSettingsPage = () => {
  const dispatch = useDispatch();
  const [mutate, { isLoading }] = useMutation(UsersAPI.verifyMfaConfig);
  const { isFetching, data } = useQuery('enable-mfa', UsersAPI.enableMfa);
  const intlMessage = useFormatMessage();

  const onSubmit = (values: { mfaVerificationCode: string }) => {
    mutate(
      {
        ...values,
        username: data!.email,
      },
      {
        onSuccess: (_) => {
          // Logout without api call to delete jwt token as it has restricted permissions
          dispatch(authActions.logoutSuccess());
          message.success(intlMessage({ id: 'mfa.enabled' }));
        },
      }
    );
  };

  const renderMfaData = () => {
    const { issuer, email, secretKey } = data!;
    return (
      <>
        <CodeDataWrapper>
          <QRCode
            size={150}
            value={`otpauth://totp/${issuer}:${email}?secret=${secretKey}`}
          />
          <SecretData>
            <div>
              <FormattedMessage id="mfa.cannotScan" tagName="b" />{' '}
            </div>
            <div>
              <FormattedMessage id="mfa.addManually" />{' '}
            </div>
            <div>
              <FormattedMessage id="mfa.account" tagName="b" />: {issuer}:
              {email}
            </div>
            <div>
              <FormattedMessage id="mfa.key" tagName="b" />: {secretKey}
            </div>
            <div>
              <FormattedMessage id="mfa.timeBased" tagName="b" />:{' '}
              <FormattedMessage id="yes" />
            </div>
          </SecretData>
        </CodeDataWrapper>
        <Formik
          validationSchema={twoFactorPinCodeValidationSchema(intlMessage)}
          initialValues={{ mfaVerificationCode: '' }}
          onSubmit={onSubmit}
        >
          <MfaCodeForm loading={isLoading} />
        </Formik>
      </>
    );
  };

  return (
    <>
      <Header title={intlMessage({ id: 'mfa' })} />
      <FormattedMessage id="mfa.useApp" tagName="p" />
      {isFetching && <Loader />}
      {data && renderMfaData()}
    </>
  );
};
